import { useState } from 'react';
import { usePageFiltersContext } from '@/finsight/application/PageFilters/PageFiltersContext';
import { getSubscribeTexts } from '@/finsight/ui/components/deals/helpers';
import { UserPlanType } from '@/users/domain/UserPlan';

interface ISubscriptionProps {
  subscriptionId: string,
  subscriptionSubgroupName: string,
  subscriptionName: string,
  isSubscribed: boolean,
  subscriptionRequiredPlan: UserPlanType,
}

export const useDealSubscriptions = (initSubscriptions: ISubscriptionProps | null) => {
  const {
    productFilters: products,
    regionFilters: regions,
    includedProductIds: productIds,
    includedRegionIds: regionIds,
  } = usePageFiltersContext();
  const [subscriptions, setSubscriptions] = useState(initSubscriptions);

  const subscribeTexts = (status?): string => {
    if (!subscriptions) return '';
    const { isSubscribed } = subscriptions;
    return getSubscribeTexts({ isSubscribed, productIds, regionIds, products, regions }, status);
  };

  return {
    subscriptions,
    setSubscriptions,
    subscribeButtonText: subscribeTexts(false),
    subscribeSuccessMessage: subscribeTexts(true),
  };
};
